import { Component, ChangeDetectorRef, EventEmitter, HostListener, NgZone, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  LoaderService, CfetBaseComponent, CfetPageNamesConstant, CfetService,
  CFETILMEndpointsConstant, CfetErrorMessagesConstant, ErrorService
} from '../../../cfet-core';
import { environment } from '../../../../environments/environment';
import { LocationStrategy, Location } from '@angular/common';

@Component({
    selector: 'app-customer-profile-utf-form',
    templateUrl: './customer-profile-utf-form.component.html',
    styleUrls: ['./customer-profile-utf-form.component.scss'],
    standalone: false
})
export class CustomerProfileUtfFormComponent extends CfetBaseComponent implements OnInit {

  customerProfileFormGroup: UntypedFormGroup;
  securityCode: UntypedFormControl;
  securityCodeError: boolean;
  timeExpired: boolean;
  showSendCode = true;
  showCodeVerification = false;
  returnUrl = '';
  hideStaticText = false;
  wirelessNumber = '';
  emailAddress = '';
  attID = '';
  showNumberSection = true;
  showEmailSection = false;
  displayUsedNumber = true;
  displayUsedEmail = false;
  useEmailInstead = true;
  useNumberInstead = false;
  getPersonalInfo: any;
  minutes: any;
  seconds: any;
  countDown: any;
  contactEmail: any;
  requestToken: any;
  addressLine1: any;
  addressLine2: any;
  selectedCity: any;
  selectedStateInWorkplace: any;
  selectedZipInWorkplace: any;
  timezone: any;
  userPassword: any;
  securityQuestion: any;
  securityAnswer: any;
  errorMessage: string;
  completeemailAddress: any;
  updatedPersonalInfo: any;
  showLoading = false;
  agencyEmail: string;
  hasDomainValue: string;
  openCancelModal = '';
  showCancelModal = false;
  showCompleteProfileSection = false;
  showInactivityModal = true;
  countDownSession: any;
  openInactivityModal = '';
  checkOtpPage = true;
  c_ID: any;
  singleIdForm: any = {};
  singleIdInfo: any = {};
  consumer_Id: any;
  isfirstneterror: boolean = false;

  config: any;
  linkCuser = '';
  @Output() showCompleteProfile: any = new EventEmitter<any>();
  @Output() progressTrackerEvent = new EventEmitter<any>();
  @Output() goBackToPwdPage = new EventEmitter<any>();
  AmUtfHeaders: any;
  amdbat: any;
  accessMitigation: any;
  consErrMsg: any;

  constructor(private router: Router,
    private errorService: ErrorService,
    private loaderService: LoaderService,
    private locationStrategy: LocationStrategy,
    private location: Location,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private cfetService: CfetService) {
    super();
    history.pushState(null, null, window.location.href);
    // to check if back or forward button is pressed.
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  ngOnInit() {
    this.agencyEmail = sessionStorage.getItem('agencyEmail');
    this.hasDomainValue = sessionStorage.getItem('hasDomainValue');
    console.log('Retrieved agencyEmail:', this.agencyEmail);
    this.securityCode = new UntypedFormControl('', { validators: [Validators.required, Validators.minLength(6)] });
    this.customerProfileFormGroup = new UntypedFormGroup({
      securityCode: this.securityCode
    });
    this.progressTrackerEvent.emit('confirmOtppage');
     if (sessionStorage.getItem('AMUTFHeaders') && Object.keys(sessionStorage.getItem('AMUTFHeaders')).length !== 0) {
      const rawHeaders = sessionStorage.getItem('AMUTFHeaders');
      if (rawHeaders && rawHeaders !== 'undefined') {
        try {
          this.AmUtfHeaders = JSON.parse(rawHeaders);
        } catch {
          console.warn('Invalid AMUTFHeaders');
        }
      }
      this.amdbat = this.AmUtfHeaders['accessToken'] ? this.AmUtfHeaders['accessToken'] : '';
    }
    if (sessionStorage.getItem('ngStorage-savedData') && Object.keys(sessionStorage.getItem('ngStorage-savedData')).length !== 0) {
      const rawPersonal = sessionStorage.getItem('ngStorage-savedData');
      if (rawPersonal && rawPersonal !== 'undefined') {
        try {
          this.getPersonalInfo = JSON.parse(rawPersonal);
        } catch {
          console.warn('Invalid personal info');
        }
      }
      this.wirelessNumber = (sessionStorage.getItem('contactCTN') || '')?.replace(/\D/g, '');
      if (this.getPersonalInfo && this.wirelessNumber && this.getPersonalInfo.emailaddress) {
        this.wirelessNumber = (sessionStorage.getItem('contactCTN') || '')?.replace(/\D/g, '')?.slice(6, 10);
        this.completeemailAddress = this.getPersonalInfo.emailaddress;
        this.attID = this.getPersonalInfo.attID;
        const tempEmail = this.getPersonalInfo.emailaddress.split('@');
        this.emailAddress = tempEmail[0].slice(tempEmail[0].length - 4, tempEmail[0].length) + '@' + tempEmail[1];
        this.addressLine1 = this.getPersonalInfo.address1;
        this.addressLine2 = this.getPersonalInfo.address2;
        this.selectedCity = this.getPersonalInfo.city;
        this.selectedStateInWorkplace = this.getPersonalInfo.state;
        this.selectedZipInWorkplace = this.getPersonalInfo.zipCode;
      }
    }
    if (sessionStorage.getItem('profileInformation') && Object.keys(sessionStorage.getItem('profileInformation')).length !== 0) {
      const rawProfile = sessionStorage.getItem('profileInformation');
      if (rawProfile && rawProfile !== 'undefined') {
        try {
          this.updatedPersonalInfo = JSON.parse(rawProfile);
        } catch {
          console.warn('Invalid profileInformation');
        }
      }
      this.userPassword = this.updatedPersonalInfo.pwd;
      this.securityQuestion = this.updatedPersonalInfo.securityQuestion;
      this.securityAnswer = this.updatedPersonalInfo.securityAnswer;
      this.timezone = this.updatedPersonalInfo.timeZone;
    }
    this.getSessionData();
    if (environment.enableUTFSessionTimeout && this.checkOtpPage) {
      this.checkInactivity();
    }
    this.returnUrl = (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) ?
      JSON.parse(sessionStorage.getItem('returnUrl')) : environment.att_Utf_Path;
  }

  getSessionData() {
    if (sessionStorage.getItem('c_ID') && sessionStorage.getItem('separateId') && sessionStorage.getItem('separateId') === 'true') {
      this.c_ID = sessionStorage.getItem('c_ID');
    }
    if (sessionStorage.getItem('linked_c_user')) {
      this.linkCuser = sessionStorage.getItem('linked_c_user');
    }
    this.singleIDDetails();
    this.unauthDetails();
  }

  singleIDDetails() {
    try {
      const rawSingleIdForm = sessionStorage.getItem('singleIdForm');
      const rawLinkCuser = sessionStorage.getItem('linkcuser');
      if (
        (rawSingleIdForm && rawSingleIdForm !== 'undefined') ||
        (rawLinkCuser && rawLinkCuser !== 'undefined')
      ) {
        if (rawSingleIdForm && rawSingleIdForm !== 'undefined') {
          this.singleIdForm = JSON.parse(rawSingleIdForm);
          this.consumer_Id = this.singleIdForm?.newEmail;
        }
        if (rawLinkCuser && rawLinkCuser !== 'undefined') {
          this.linkCuser = JSON.parse(rawLinkCuser);
        }
        const rawSingleIDInfo = sessionStorage.getItem('ngStorage-singleIDInfo');
        if (rawSingleIDInfo && rawSingleIDInfo !== 'undefined') {
          this.singleIdInfo = JSON.parse(rawSingleIDInfo);
          this.attID = this.singleIdInfo?.attID;
        }
      }
    } catch (e) {
      console.warn('Invalid singleIDDetails session data');
    }
  }

  unauthDetails() {
    try {
      const rawUserId = sessionStorage.getItem('userID');
      const rawUnAuth = sessionStorage.getItem('unAuth');
      if (
        (rawUserId && rawUserId !== 'undefined') ||
        (rawUnAuth && rawUnAuth !== 'undefined')
      ) {
        if (rawUserId && rawUserId !== 'undefined') {
          this.c_ID = JSON.parse(rawUserId);
        }
        if (rawUnAuth && rawUnAuth !== 'undefined') {
          this.accessMitigation = JSON.parse(rawUnAuth);
        }
      }
    } catch (e) {
      console.warn('Invalid unauthDetails session data');
    }
  }

  // for capturing the browser back button event
  @HostListener('window: popstate', ['$event'])
  onPopState(event: Event): void {
    event.preventDefault();
    if (this.showCodeVerification) {
      this.back({ key: 'Enter' });
    } else {
      this.location.back();
    }
    window.scrollTo(0, 0);
  }

  checkOTP() {
    if (this.securityCode.value === '' || this.securityCode.value !== undefined) {
      this.securityCodeError = false;
      this.timeExpired = false;
      this.errorService.showError.next(false);
    }
  }

  showEmail(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showEmailSection = true;
      this.showNumberSection = false;
    }
  }

  showNumber(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showEmailSection = false;
      this.showNumberSection = true;
    }
  }

  sendCode(event) {
    const contactCTN = sessionStorage.getItem('contactCTN');
    console.log('Contact CTN:', contactCTN);
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13 && this.getPersonalInfo) {
      this.showLoading = true;
      const requestParam = {
        'userid': this.getPersonalInfo.emailaddress.trim(),
        'company_id': 21,
        'verification_attributes': [
          {
            'attribute_name': 'sn',
            'attribute_value': this.getPersonalInfo.lastname
          }
        ],
        'notification_flow': 'actv'
      };
      console.log('USERID:',this.getPersonalInfo.emailaddress.trim())
      if (!this.showNumberSection && this.showEmailSection) {
        requestParam['notification_method'] = 'email';
        requestParam['notification_value'] = this.getPersonalInfo.emailaddress.trim();
      } else if (this.showNumberSection && !this.showEmailSection) {
        requestParam['notification_method'] = 'sms';
        requestParam['notification_value'] = (contactCTN || '').replace(/\D/g, '');
      }
      this.wirelessNumber = (sessionStorage.getItem('contactCTN') || '')?.replace(/\D/g, '');
      if ( this.wirelessNumber && this.getPersonalInfo?.emailaddress ) {
        this.wirelessNumber = this.wirelessNumber?.slice(6, 10);
        this.completeemailAddress = this.getPersonalInfo.emailaddress;
        const tempEmail = this.getPersonalInfo.emailaddress.split('@');
        this.emailAddress = tempEmail[0].slice(tempEmail[0].length - 4, tempEmail[0].length) + '@' + tempEmail[1];
      }
      this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((response: any) => {
        if (response) {
          this.showLoading = false;
          this.displayNumberOrEmailSection();
          this.checkOtpPage = false;
          clearInterval(this.countDownSession);
          this.showSendCode = false;
          this.showCodeVerification = true;
          this.securityCode.reset();
          window.scrollTo(0, 0);
          this.minutes = '00';
          this.seconds = '00';
          if (response.otp_expire_time) {
            this.securityCodeError = false;
            this.timeExpired = false;
            this.timer(response.otp_expire_time);
          }
        }
      }, (error) => {
        this.showLoading = false;
      });
    }
  }

  displayNumberOrEmailSection() {
    if (this.showNumberSection && !this.showEmailSection) {
      this.displayUsedNumber = true;
      this.displayUsedEmail = false;
      this.useEmailInstead = true;
      this.useNumberInstead = false;
    } else if (!this.showNumberSection && this.showEmailSection) {
      this.displayUsedNumber = false;
      this.displayUsedEmail = true;
      this.useEmailInstead = false;
      this.useNumberInstead = true;
    }
  }

  cancel(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  resendCode(event) {
    const contactCTN = sessionStorage.getItem('contactCTN');
    console.log('Contact CTN:', contactCTN);
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.securityCode.reset();
      clearInterval(this.countDown);
      // Hide the error component banner
      this.errorService.showError.next(false);
      this.securityCodeError = false;
      this.timeExpired = false;
      this.minutes = '00';
      this.seconds = '00';
      if (this.getPersonalInfo) {
        const requestParam = {
          'userid': this.getPersonalInfo.emailaddress.trim(),
          'company_id': 21,
          'verification_attributes': [
            {
              'attribute_name': 'sn',
              'attribute_value': this.getPersonalInfo.lastname
            }
          ],
          'notification_flow': 'actv'
        };
        if (!this.showNumberSection && this.showEmailSection) {
          requestParam['notification_method'] = 'email';
          requestParam['notification_value'] = this.getPersonalInfo.emailaddress.trim();
        } else if (this.showNumberSection && !this.showEmailSection) {
          requestParam['notification_method'] = 'sms';
          requestParam['notification_value'] = (contactCTN || '').replace(/\D/g, '');
        }
        this.showLoading = true;
        this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((response: any) => {
          this.setTimer(response);
        }, (error) => {
          this.showLoading = false;
        });
      }
    }
  }

  setTimer(response) {
    if (response) {
      this.showLoading = false;
      this.minutes = '00';
      this.seconds = '00';
      if (response.otp_expire_time) {
        this.securityCodeError = false;
        this.timeExpired = false;
        this.timer(response.otp_expire_time);
      }
    }
  }

  useEmail(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showSendCode = true;
      this.showCodeVerification = false;
      this.checkOtpPage = true;
      this.showNumberSection = false;
      this.showEmailSection = true;
      this.securityCode.reset();
      // Hide the error component banner
      this.errorService.showError.next(false);
      this.securityCodeError = false;
      this.timeExpired = false;
      clearInterval(this.countDown);
    }
  }

  useNumber(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showSendCode = true;
      this.showCodeVerification = false;
      this.checkOtpPage = true;
      this.showNumberSection = true;
      this.showEmailSection = false;
      this.securityCode.reset();
      // Hide the error component banner
      this.errorService.showError.next(false);
      this.securityCodeError = false;
      this.timeExpired = false;
      clearInterval(this.countDown);
    }
  }

  disabledSubmitButton() {
    if (this.securityCode.value === '' || this.securityCode.value === undefined || this.securityCode.value === null
      || this.errorService.isErrorBannerOpened || this.securityCodeError) {
      return true;
    } else {
      return false;
    }
  }

  getConfigValue() {
    if (this.amdbat) {
      this.config = {
        ACCESS_TOKEN: this.amdbat
      };
    } else {
      this.config = {};
    }
  }

  goBack(event) {
    if (event.type === 'click' || event.key === 'Enter' || event.keyCode === 13) {
      sessionStorage.setItem('returningFromPwdPage', 'true');
      this.goBackToPwdPage.emit(true);
    }
  }

  submit() {
    console.log(' SUBMIT METHOD TRIGGERED');
    try {
      this.showLoading = true;
      this.getConfigValue();
      const profileArr = [
        { attribute_name: "tosFlag", attribute_value: "N" },
        { attribute_name: "Timezone", attribute_value: this.timezone ? this.timezone : "" },
        { attribute_name: "SECURITY_QUESTION", attribute_value: this.securityQuestion },
        { attribute_name: "SECURITY_ANSWER", attribute_value: this.securityAnswer }
      ];
      const agencyEmail = sessionStorage.getItem('agencyEmail');
      const hasDomainValue = sessionStorage.getItem('hasDomainValue');
      if (agencyEmail && hasDomainValue === 'true') {
        const parts = agencyEmail.split('@');
        if (parts.length === 2 && parts[1].trim() !== '') {
          profileArr.push({
            attribute_name: 'isEVSP',
            attribute_value: 'TRUE'
          });
        }
      }
      console.log('PROFILE:', profileArr);
      const requestParam = this.modifyRequestParam({
        userid: this.getPersonalInfo.emailaddress.trim(),
        company_id: environment.companyId,
        otp: String(this.securityCode.value),
        password: this.userPassword,
        profile: profileArr
      });
      console.log('REQUEST PARAM:', requestParam);
      this.cfetService
        .cfetLivePostHeader(
          requestParam,
          CFETILMEndpointsConstant.ACTIVATE_USER_V4,
          this.config
        )
        .subscribe(
          (data: any) => {
            console.log('SUCCESS BLOCK:', data);
            this.showLoading = false;
            this.navigateToProfileConfirmation(data);
          },
          (error) => {
            console.log('ERROR BLOCK:', error);
            const res = error?.error;
            console.log('ERROR RESPONSE:', res);
            const isSuccess =
              res?.status?.toLowerCase?.() === 'success' ||
              res?.statusCode === 5035 ||
              res?.message?.toLowerCase?.().includes('success');
            if (isSuccess) {
              console.log(' SUCCESS FROM ERROR BLOCK');
              this.showLoading = false;
              this.navigateToProfileConfirmation(res);
              return;
            }
            this.showLoading = false;
            this.displayErrorMethod(res || {});
          }
        );
    } catch (e) {
      console.error('SUBMIT CRASH:', e);
      this.showLoading = false;
    }
  }


  displayErrorMethod(errorResponse) {
    if (
      errorResponse.errorcode &&
      errorResponse.errorcode === 1020
    ) {
      this.showLoading = false;
      this.showSendCode = false;
      this.showCodeVerification = false;
      this.showCompleteProfileSection = false;
      this.showCompleteProfile.emit(true);
      this.checkOtpPage = false;
      clearInterval(this.countDownSession);
      const fromOtpPage = {
        action: "fromOtpPage",
        securityQuestion: this.securityQuestion,
        securityAnswer: this.securityAnswer,
        timeZone: this.timezone,
      };
      sessionStorage.setItem(
        "fromOtpPage",
        JSON.stringify(fromOtpPage)
      );
    } else if (
      errorResponse.errorcode &&
      errorResponse.errorcode === 1106 &&
      errorResponse.variables
    ) {
      this.displayConsumerError(errorResponse);
    } else {
      this.securityCodeError = true;
      this.timeExpired = false;
      this.errorMessage =
        CfetErrorMessagesConstant.CFET_CODE_INCORRECT_ERROR_MESSAGE;
      this.errorService.displayErrorMessage(this.errorMessage);
      this.showLoading = false;
      window.scrollTo(0, 0);
    }
  }

  displayConsumerError(errorResponse) {
    this.showLoading = false;
    this.errorMessage = errorResponse.message ? errorResponse.message : CfetErrorMessagesConstant.CFET_DEFAULT_ERROR_MESSAGE;
    const consumerMsgCheck = 'Consumer:ID';
    const index = errorResponse.variables.findIndex(el => el.includes(consumerMsgCheck));
    const firstnetMsgCheck = 'FirstNet';
    const index2 = errorResponse.variables.findIndex(el => el.includes(firstnetMsgCheck));
    if (index >= 0) {
      const getConsumerMsg = errorResponse.variables[index];
      const consumerError = getConsumerMsg.split(':');
      const getMsgWithID = consumerError[1];
      const getErrorID = getMsgWithID.slice(2);
      this.consErrMsg = getConsumerMsg.substring(getConsumerMsg.indexOf(getMsgWithID));
      this.consErrMsg = this.consErrMsg ? this.consErrMsg : this.errorMessage;
      if (
        getErrorID === "20107" ||
        getErrorID === "30000" ||
        getErrorID === "20106" ||
        getErrorID === "10006" ||
        getErrorID === "101032" ||
        getErrorID === "10001" ||
        getErrorID === "10101"
      ) {
        this.displayErrorBanner(getErrorID);
      } else if (
        getErrorID === "20105" ||
        getErrorID === "10105" ||
        getErrorID === "10110" ||
        getErrorID === "forbidden"
      ) {
        this.displayOtherErrorBanner(getErrorID);
      } else {
        this.errorService.displayErrorMessage(this.consErrMsg);
        window.scrollTo(0, 0);
      }
    } else if (index2 >= 0) {
      this.isfirstneterror = true;
      const firstneterrorMsg = errorResponse.variables[index2];
      const firstnetError = firstneterrorMsg.split(':');
      const getErrorID = firstnetError[1];
      this.consErrMsg = firstnetError[2];
      this.consErrMsg = this.consErrMsg ? this.consErrMsg : this.errorMessage;
      if (getErrorID) {
        this.displayErrorBanner(getErrorID);
      } else {
        this.errorService.displayErrorMessage(this.consErrMsg);
        window.scrollTo(0, 0);
      }
    } else {
      this.errorService.displayErrorMessage(this.errorMessage);
      window.scrollTo(0, 0);
    }
  }

  displayErrorBanner(errorID) {
    if (!this.isfirstneterror) {
      if (errorID === "20107") {
        const errorsMessages = [
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[5].msg[0],
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[5].msg[1],
        ];
        const infoLink = {
          anchorLink: environment.learnMore,
          anchorText: 'Learn More'
        };
        this.errorService.displayErrorInfoMessage(errorsMessages, infoLink, false);
        window.scrollTo(0, 0);
      } else if (errorID === "30000") {
        const errorsMessages = [
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[6].msg[0],
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[6].msg[1],
        ];
        this.errorService.displayErrorMessageList(errorsMessages);
        window.scrollTo(0, 0);
      } else if (errorID === "20106") {
        const errorsMessages = [
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[7].msg[0],
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[7].msg[1],
        ];
        this.errorService.displayErrorMessageList(errorsMessages);
        window.scrollTo(0, 0);
      } else if (errorID === "10006") {
        const errorsMessages = [
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[8].msg[0],
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[8].msg[1],
        ];
        this.errorService.displayErrorMessageList(errorsMessages);
        window.scrollTo(0, 0);
      } else if (errorID === "101032") {
        const errorsMessages = [
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[9].msg[0],
          CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[9].msg[1],
        ];
        this.errorService.displayErrorMessageList(errorsMessages);
        window.scrollTo(0, 0);
      } else if (errorID === "10001") {
        const errorsMessages = CfetErrorMessagesConstant.CFET_ERROR_10001;
        this.errorService.displayErrorMessage(errorsMessages);
        window.scrollTo(0, 0);
      } else if (errorID === "10101") {
        const errorsMessages = CfetErrorMessagesConstant.CFET_ERROR_10101;
        this.errorService.displayErrorMessage(errorsMessages);
        window.scrollTo(0, 0);
      }
      else {
        this.errorService.displayErrorMessage(this.consErrMsg);
        window.scrollTo(0, 0);
      }
    } else {
      const errormsg2 = 'CFET_FIRSTNETERROR_' + errorID;
      if (CfetErrorMessagesConstant[errormsg2]) {
        const errorsMessages = CfetErrorMessagesConstant[errormsg2];
        this.errorService.displayErrorMessage(errorsMessages);
        window.scrollTo(0, 0);
      } else {
        this.errorService.displayErrorMessage(this.consErrMsg);
        window.scrollTo(0, 0);
      }
    }

  }

  displayOtherErrorBanner(errorID) {
    if (errorID === "20105") {
      const errorsMessages = [
        CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[10].msg[0],
        CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[10].msg[1],
      ];
      this.errorService.displayErrorMessageList(errorsMessages);
      window.scrollTo(0, 0);
    } else if (errorID === "10105") {
      const errorsMessages = [
        CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[11].msg[0],
        CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[11].msg[1],
      ];
      this.errorService.displayErrorMessageList(errorsMessages);
      window.scrollTo(0, 0);
    } else if (errorID === "10110") {
      const errorsMessages = [
        CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[12].msg[0],
        CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[12].msg[1],
      ];
      this.errorService.displayErrorMessageList(errorsMessages);
      window.scrollTo(0, 0);
    } else if (errorID === "forbidden") {
      const errorsMessages = [
        CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[13].msg[0],
        CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST[13].msg[1],
      ];
      this.errorService.displayErrorMessageList(errorsMessages);
      window.scrollTo(0, 0);
    }
  }

  modifyRequestParam(requestParam) {
    console.log('🔥 ENTER modifyRequestParam:', requestParam);
    try {
      if (!requestParam.profile) {
        requestParam.profile = [];
      }
      if (this.accessMitigation) {
        //new/existing error scenario
        requestParam.profile.push({
          'attribute_name': 'c_id',
          'attribute_value': 'NEW'
        },
          {
            'attribute_name': 'linked_c_user',
            'attribute_value': 'linkF'
          });
      } else if (this.attID) {
        requestParam.profile.push({
          'attribute_name': 'c_id',
          'attribute_value': this.attID
        },
          {
            'attribute_name': 'linked_c_user',
            'attribute_value': 'linkC'
          });
      } else if (this.c_ID) {  //new/existing non email id format scenario
        requestParam.profile.push(
          {
            'attribute_name': 'c_id',
            'attribute_value': this.c_ID
          },
          {
            'attribute_name': 'linked_c_user',
            'attribute_value': 'linkF'
          });
      } else if (this.linkCuser !== '') {
        // new/new
        requestParam.profile.push(
          {
            'attribute_name': 'linked_c_user',
            'attribute_value': 'linkF'
          },
          {
            'attribute_name': 'c_id',
            'attribute_value': 'NEW'
          });
      }
    } catch (e) {
      console.error('modifyRequestParam crash:', e);
    }
    return requestParam;
  }
  navigateToProfileConfirmation(data) {
    console.log('ENTERED navigateToProfileConfirmation:', data);
    try {
      const isSuccess =
        data?.userDetails?.status?.toLowerCase?.() === 'success' ||
        data?.status?.toLowerCase?.() === 'success';
      if (isSuccess) {
        this.showLoading = false;
        this.showSendCode = false;
        this.showCodeVerification = false;
        this.checkOtpPage = false;
        if (data?.userDetails?.utfSid) {
          sessionStorage.setItem('utfToken', data.userDetails.utfSid);
        }
        if (this.linkCuser == '') {
          const requestParam2 = {
            'company_id': environment.companyId,
            'userid': this.getPersonalInfo.emailaddress.trim(),
            'notification_flow': 'epv',
            'notification_method': 'email',
            'notification_value': this.getPersonalInfo.emailaddress.trim(),
          };
          console.log('CALLING USER_ACTIVATION_AUTHCODE_ILM', requestParam2);
          this.cfetService
            .cfetLivePost(
              requestParam2,
              CFETILMEndpointsConstant.USER_ACTIVATION_AUTHCODE_ILM
            )
            .subscribe(
              (res1: any) => {
                console.log('SECOND API SUCCESS:', res1);
                if (res1?.status?.toLowerCase?.() === 'success') {
                  this.showLoading = false;
                  this.showSendCode = false;
                  this.showCodeVerification = false;
                  this.checkOtpPage = false;
                  clearInterval(this.countDownSession);
                  this.router.navigate([
                    CfetPageNamesConstant.COMPLETE_PROFILE_CONFIRMATION_UTF
                  ]);
                  this.errorService.showError.next(false);
                }
              },
              (error) => {
                console.log('SECOND API ERROR:', error);
                this.securityCodeError = false;
                this.errorMessage = error?.error?.message;
                this.errorService.displayErrorMessage(this.errorMessage);
                this.showLoading = false;
                window.scrollTo(0, 0);
              }
            );
        } else {
          this.router.navigate([
            CfetPageNamesConstant.COMPLETE_PROFILE_CONFIRMATION_UTF
          ]);
          this.errorService.showError.next(false);
        }

      } else {
        console.warn('Unexpected response:', data);
        this.showLoading = false;
      }

    } catch (e) {
      console.error('navigation crash:', e);
      this.showLoading = false;
    }
  }
  cancelSubmit(event) {
    if (event.type === 'click' || event.key === 'Enter' || event.keyCode === 13) {
      if (this.isEncoded(this.returnUrl)) {
        this.redirectUrl(decodeURIComponent(this.returnUrl));
      } else {
        this.redirectUrl(this.returnUrl);
      }
    }
  }

  isEncoded(url) {
    if (url !== '') {
      return url !== decodeURIComponent(url);
    }
  }

  back(event) {
    if (event.type === 'click' || event.key === 'Enter' || event.keyCode === 13) {
      this.showSendCode = true;
      this.showCodeVerification = false;
    }
  }

  redirectUrl(url) {
    window.location.href = url;
  }

  timer(expire_minutes) {
    expire_minutes = expire_minutes || 5; // Default to 5 minutes if not provided
    const expireSeconds = Number(expire_minutes) * 60;
    const countDownDate = new Date().getTime() + (expireSeconds * 1000);
    // Force re-entry into Angular's zone so the display updates every tick, since interceptors upstream may run outside it
    this.ngZone.run(() => {
      this.countDown = setInterval(() => {
        const currentTime = new Date().getTime();
        const timeDiff = countDownDate - currentTime;
        this.minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        this.seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
        if (this.minutes < 10) {
          this.minutes = '0' + this.minutes;
        }
        if (this.seconds < 10) {
          this.seconds = '0' + this.seconds;
        }
        if (timeDiff < 0) {
          this.minutes = '00';
          this.seconds = '00';
          clearInterval(this.countDown);
          this.securityCodeError = false;
          this.timeExpired = true;
        }
        // Force the view to reflect the tick now rather than waiting on the next zone-triggered event.
        this.cdr.detectChanges();
      }, 350);
    });
  }

  closeCancelModal(event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

  closeInactivityModal(event) {
    if (event === 'modalClose') {
      this.openInactivityModal = 'close';
      clearInterval(this.countDownSession);
    }
  }

  @HostListener('window:load')
  @HostListener('document:mousemove')
  @HostListener('document:keyup')
  @HostListener('document:click')
  @HostListener('window:scroll')
  @HostListener('document:touchstart', ['$event']) onMove($event?: any) {
    if (environment.enableUTFSessionTimeout && this.checkOtpPage && this.openInactivityModal !== 'open') {
      clearInterval(this.countDownSession);
      this.checkInactivity();
    }
  }

  checkInactivity() {
    const countDownDate = new Date().getTime() + 600000;
    this.countDownSession = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeDiff = countDownDate - currentTime;

      if (timeDiff < 30000 && timeDiff > 0) {
        setTimeout(() => {
          this.openInactivityModal = 'open';
        });
        this.showCancelModal = false;
      }
      if (timeDiff < 0) {
        clearInterval(this.countDownSession);
        setTimeout(() => {
          this.openInactivityModal = 'close';
        });
        let returnUrl = '';
        if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
          returnUrl = sessionStorage.getItem('returnUrl');
        }
        sessionStorage.clear();
        if (returnUrl !== '') {
          sessionStorage.setItem('returnUrl', returnUrl);
        }
        sessionStorage.setItem('fnStatus', 'fnStatus=eligible-pending');
        window.location.href = CfetPageNamesConstant.SESSION_TIME_OUT_UTF;
      }
      // Force the view to reflect the tick now rather than waiting on the next zone-triggered event.
      this.cdr.detectChanges();
    }, 350);
  }

}
